// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"badf936c","879":"e102f569"}[chunkId] + ".chunk.js";
};